import React from 'react'

import { type Question } from '~/hooks/useSurveyQuery'
import { findByPath } from '~/utils'

import { useNormalAnswersArrayData } from './useNormalAnswersArrayData'

export const useNormalAnswersData = (question: Question) => {
  const answersArrayData = useNormalAnswersArrayData()

  return React.useMemo(
    () =>
      findByPath(
        answersArrayData,
        '0.question.question_id',
        question.question_id,
      ) ?? [],
    [answersArrayData, question.question_id],
  )
}
